var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('sales-order-form',{attrs:{"loading":_vm.loading,"salesOrderData":_vm.salesOrder,"formErrors":_vm.formErrors},on:{"salesOrderSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }